/* eslint-disable @typescript-eslint/no-explicit-any */
import casa from "../../../../assets/img/casa.png";
import departamento from "../../../../assets/img/departamento.png";
import cabaña from "../../../../assets/img/cabaña.png";
import hotel from "../../../../assets/img/hotel.png";
import casaHuespedes from "../../../../assets/img/hostel.png";

const Espacio = ({ setForm, form }: any) => {
  const espacio = [
    {
      name: "Casa",
      icon: casa,
    },
    {
      name: "Departamento",
      icon: departamento,
    },
    {
      name: "Hotel",
      icon: hotel,
    },
    {
      name: "Cabaña",
      icon: cabaña,
    },
    {
      name: "Casa de huéspedes",
      icon: casaHuespedes,
    },
  ];

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "type":
        {
          setForm({
            ...form,
            type: value,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid grid-cols-1  lg:grid-cols-2 gap-10 py-5 px-5">
        <div>
          <span className="font-bold text-black mb-2 block">
            ¿Cuál es la opción que describe tu espacio?
          </span>
          <div className="grid grid-cols-2 gap-5">
            {espacio.map((t) => {
              if (form.type == t.name) {
                return (
                  <label
                    className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                    style={{ borderRadius: "20px" }}
                  >
                    <span className="flex text-black items-center">
                      <img src={t.icon} width={20} className="me-2" alt="" />
                      {t.name}
                    </span>
                    <button
                      className="hidden"
                      name="type"
                      onClick={(event) => onClick(event, t.name)}
                    ></button>
                  </label>
                );
              }

              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex text-black items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="type"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Espacio;
